<div class="otp-modal">
  <div class="otp-header">
    <h2 class="title">{{ title() }}</h2>
    <p class="subtitle">{{ subtitle() }}</p>
  </div>

  <div class="otp-auth">
    <img src="shared-assets/images/otp-icon.png" alt="OTP Icon" class="auth-icon" />
    <p class="auth-text">Authenticator App</p>
  </div>

  <form class="otp-form" [formGroup]="otpForm" (ngSubmit)="onSubmit()">
    <div
      class="code-input-container"
      formArrayName="codeDigits"
      (paste)="handlePaste($event)"
    >
      <div class="code-box-container">
        @for (digit of codeDigits.controls; track $index) {
          <input
            #codeInput
            type="text"
            maxlength="1"
            class="code-input"
            placeholder=""
            [formControlName]="$index"
            (keyup)="onCodeInput($event, $index)"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]*"
            [attr.aria-label]="'Authentication code digit ' + ($index + 1)"
            [ngClass]="{ error: (digit.invalid && digit.touched) || errorMessage() }"
          />
        }
      </div>

      <div class="error-message" [class.hidden]="!errorMessage()">
        <mat-icon class="error-icon">error</mat-icon>
        <span> {{ errorMessage() }}</span>
      </div>

    </div>

    <div class="action-buttons">
      <app-button buttonVariant="otp-secondary" buttonType="button" (buttonClick)="onCancel()">
        Cancel
      </app-button>
      <app-button
        buttonVariant="otp-primary"
        buttonType="submit"
        [state]="submitButtonState"
      >
        Submit
      </app-button>
    </div>
  </form>

  @if(isLoading()) {
    <app-loading-spinner [visible]="isLoading()" [isOverlay]="true" size="large" />
  }
</div>
